// @flow

import {
  GET_LAYOUT_STATIC_DATA_IN_PROGRESS,
  GET_LAYOUT_STATIC_DATA_SECCESS,
  GET_LAYOUT_STATIC_ERROR,
  SEND_PAYMENT_IN_PROGRESS,
  SEND_PAYMENT_RESPONSE,
  SEND_PAYMENT_ERROR,
} from './actionTypes';
import Config from '../../core/config/index';
import 'es6-promise/auto';
import 'isomorphic-fetch';

export function getLayoutStaticDataInProgress() {
  return {
    type: GET_LAYOUT_STATIC_DATA_IN_PROGRESS,
  };
}
export function getLayoutStaticDataSuccess(layoutStaticData) {
  return {
    type: GET_LAYOUT_STATIC_DATA_SECCESS,
    layoutStaticData,
  };
}
export function getLayoutStaticDataError() {
  return {
    type: GET_LAYOUT_STATIC_ERROR,
  };
}
export function sendPaymentInProgress() {
  return {
    type: SEND_PAYMENT_IN_PROGRESS,
  };
}
export function sendPaymentResponse(sendPaymentResponse) {
  return {
    type: SEND_PAYMENT_RESPONSE,
    sendPaymentResponse,
  };
}
export function sendPaymentError(sendPaymentResponse) {
  return {
    type: SEND_PAYMENT_ERROR,
    sendPaymentResponse,
  };
}

export function getLayoutStaticData(payload) {
  return async (dispatch) => {
    dispatch(getLayoutStaticDataInProgress());

    if (payload) {
      dispatch(getLayoutStaticDataSuccess(payload));
    } else {
      dispatch(getLayoutStaticDataError());
    }
  };
}

export function sendPayment(payload) {
  return async (dispatch) => {
    const {
      booking: {
        post: { url, params },
      },
      errorMessage,
    } = Config.payment;

    dispatch(sendPaymentInProgress());

    try {
      const body = JSON.stringify(payload);
      const response = await fetch(window.location.origin + url, { ...params, ...{ body } });
      const data = await response.json();

      dispatch(sendPaymentResponse({ sendPaymentResponse: data, userData: payload }));
    } catch (e) {
      console.error(e);
      dispatch(sendPaymentError({ sendPaymentResponse: errorMessage, userData: payload }));
    }
  };
}
